import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[glinkWidgetToggle]'
})
export class GLinkWidgetToggleDirective
{
    /**
     * Constructor
     *
     * @param {ElementRef} elementRef
     */
    constructor(
        public elementRef: ElementRef
    )
    {
    }
}
